import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  gravityFromSlider,
  savePhysicsTweaks,
  sliderFromGravity,
  sliderFromSpeed,
  speedFromSlider,
  type PhysicsTweaks,
} from '../physicsTweaks';

export interface PhysicsTweaksPanelProps {
  tweaksRef: React.MutableRefObject<PhysicsTweaks>;
}

export const PhysicsTweaksPanel: React.FC<PhysicsTweaksPanelProps> = ({ tweaksRef }) => {
  const [open, setOpen] = useState(false);
  const [speedPct, setSpeedPct] = useState(() => sliderFromSpeed(tweaksRef.current.speed));
  const [gravPct, setGravPct] = useState(() => sliderFromGravity(tweaksRef.current.gravityStrength));
  const [trails, setTrails] = useState(() => tweaksRef.current.showTrails);
  const saveTimer = useRef<number | null>(null);

  const pushTweaks = useCallback(
    (next: PhysicsTweaks) => {
      tweaksRef.current = next;
      if (saveTimer.current !== null) window.clearTimeout(saveTimer.current);
      saveTimer.current = window.setTimeout(() => {
        saveTimer.current = null;
        savePhysicsTweaks(next);
      }, 400);
    },
    [tweaksRef],
  );

  useEffect(
    () => () => {
      if (saveTimer.current !== null) window.clearTimeout(saveTimer.current);
    },
    [],
  );

  return (
    <div className={`funil-ia-tweaks${open ? ' funil-ia-tweaks--open' : ''}`}>
      <button
        type="button"
        className="funil-ia-tweaks-toggle"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        Tweaks
      </button>
      {open && (
        <div className="funil-ia-tweaks-panel" role="dialog" aria-label="Ajustes do funil físico">
          <div className="funil-ia-tweaks-title">TWEAKS</div>
          <label className="funil-ia-tweaks-row">
            <span>Velocidade</span>
            <input
              type="range"
              min={0}
              max={100}
              value={speedPct}
              onChange={(e) => {
                const v = Number(e.target.value);
                setSpeedPct(v);
                pushTweaks({
                  ...tweaksRef.current,
                  speed: speedFromSlider(v),
                });
              }}
            />
          </label>
          <label className="funil-ia-tweaks-row">
            <span>Força gravitacional</span>
            <input
              type="range"
              min={0}
              max={100}
              value={gravPct}
              onChange={(e) => {
                const v = Number(e.target.value);
                setGravPct(v);
                pushTweaks({
                  ...tweaksRef.current,
                  gravityStrength: gravityFromSlider(v),
                });
              }}
            />
          </label>
          <label className="funil-ia-tweaks-check">
            <input
              type="checkbox"
              checked={trails}
              onChange={(e) => {
                const v = e.target.checked;
                setTrails(v);
                pushTweaks({ ...tweaksRef.current, showTrails: v });
              }}
            />
            Trails
          </label>
        </div>
      )}
    </div>
  );
};
